export const GLOBAL_MAX_TRADE_AMOUNT = '100_000_000';

// TODO: replace with BE value when implemented
export const STOP_ORDER_VALIDITY_MONTHS = 6;
